(() => {
  'use strict';
  function initialize() {
    if (window.Notify && window.theme && !window.theme.Notify) window.theme.Notify = new window.Notify();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('pcf:cart-added', async () => {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-pcf-cart-count]').forEach(element => { element.textContent = String(cart.item_count); });
    } catch (_) {}
  });
})();
